import Avatar from 'boring-avatars';
import { cn } from '../lib/utils';

const BEAM_COLORS = ['#D4D4D8', '#A1A1AA', '#183EF6', '#0622AC', '#27272A'];

export function UserAvatar({
  name,
  src,
  size = 32,
  className,
}: {
  name: string;
  src?: string | null;
  size?: number;
  className?: string;
}) {
  const seed = name.trim() || 'user';
  const image = typeof src === 'string' && src.startsWith('https://') ? src : null;
  return (
    <span
      className={cn('inline-flex shrink-0 overflow-hidden rounded-full [&>svg]:block', className)}
      style={{ width: size, height: size }}
    >
      {image ? (
        <img
          src={image}
          alt=""
          width={size}
          height={size}
          className="h-full w-full object-cover"
          referrerPolicy="no-referrer"
        />
      ) : (
        <Avatar name={seed} variant="beam" size={size} colors={BEAM_COLORS} title />
      )}
    </span>
  );
}
